import api from '../REST/api';
import { markUiAction } from '../utils/create-ui-action';

// eslint-disable-next-line import/prefer-default-export
export const fetchUsers = () => (dispatch, getState) => {
  const { users } = getState();
  if (users.length) {
    return Promise.resolve({ value: users });
  }
  return dispatch(
    markUiAction({
      type: fetchUsers.toString(),
      payload: api.getUsers(),
    }),
  );
};

fetchUsers.toString = () => 'users/fetch';
